import React from 'react';
import {WyscoutAnalyticsKPI, WyscoutAnalyticsMetric} from '@/features/players/wyscoutAnalyticsApi';

const number = (value: number): string => value.toLocaleString('en-GB', {maximumFractionDigits: 2});

const primaryValue = (metric: WyscoutAnalyticsMetric): string => {
  if (metric.availability === 'unavailable' || metric.value === null) return 'Not available';
  if (metric.unit === 'percent') return `${number(metric.value)}%`;
  return number(metric.value);
};

const secondaryValue = (metric: WyscoutAnalyticsMetric): string | null => {
  if (metric.unit === 'per_90' && metric.total !== null && metric.denominator !== null) {
    return `${number(metric.total)} total across ${number(metric.denominator)} minutes`;
  }
  if (metric.unit === 'percent' && metric.numerator !== null && metric.denominator !== null) {
    return `${number(metric.numerator)} of ${number(metric.denominator)}`;
  }
  return null;
};

const KpiGrid: React.FC<{kpis: WyscoutAnalyticsKPI[]}> = ({kpis}) => (
  <section aria-labelledby="analytics-kpis-heading" className="space-y-3">
    <h3 id="analytics-kpis-heading" className="text-base font-semibold text-gray-900 dark:text-gray-100">Role metrics</h3>
    {kpis.length === 0 ? <p className="text-sm text-gray-600 dark:text-gray-300">No role metrics are available for this selection.</p> : <div className="grid min-w-0 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {kpis.map(kpi => <article key={kpi.key} className="min-w-0 rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800">
        <h4 className="break-words text-sm font-semibold text-gray-700 dark:text-gray-200">{kpi.label}</h4>
        <p className="mt-2 break-words text-2xl font-bold text-gray-900 dark:text-gray-100">{primaryValue(kpi.metric)}</p>
        {secondaryValue(kpi.metric) && <p className="mt-1 break-words text-sm text-gray-600 dark:text-gray-300">{secondaryValue(kpi.metric)}</p>}
        {kpi.description && <p className="mt-2 break-words text-xs text-gray-500 dark:text-gray-400">{kpi.description}</p>}
      </article>)}
    </div>}
  </section>
);

export default KpiGrid;
